import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.138 15.055c-.3-.489-.7-.782-1.1-1.173V3.421c0-1.857-1.6-3.421-3.5-3.421s-3.5 1.564-3.5 3.422V13.98c-2.2 1.76-2.7 4.79-1.1 7.136.8 1.173 2.1 2.053 3.5 2.248.4.098.7.098 1.1.098q1.65 0 3-.88c2.6-1.662 3.3-4.986 1.6-7.527m-2.7 5.865c-1.6 1.076-3.8.587-4.9-.977-.5-.782-.7-1.662-.5-2.542s.7-1.662 1.5-2.15c.3-.196.4-.49.4-.783V3.422c.1-.782.8-1.467 1.6-1.467s1.5.686 1.5 1.467v11.046c0 .294.2.587.4.782.4.294.7.587 1 .978 1.1 1.564.6 3.617-1 4.692"
    }, null, -1)
  ]))]))
}
export default { render: render }